// extracted by mini-css-extract-plugin
export default {"landscape":"App__landscape-cD_h","overflowHidden":"App__overflowHidden-beYh"};